import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from "@angular/core";
import {DroppedFile} from "./dropped-file.interface";

@Directive({
  selector: "[appDragAndDropFile]"
})
export class DragAndDropFileDirective {

  @HostBinding("style.background") public background = "#fff";
  //@Input() public allowedExtensions: Array<string> = [];
  @Input() public appDragAndDropFile: Array<string> = [];
  @Output() public onDroppedFileListChanged: EventEmitter<Array<DroppedFile>> = new EventEmitter();

  constructor() {
  }

  @HostListener("dragover", ["$event"])
  public onDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = "rgba(0,0,0,0.1)";
  }

  @HostListener("dragleave", ["$event"])
  public onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = "#fff"
  }

  @HostListener("drop", ["$event"])
  public onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.background = "#fff";
    let files = event.dataTransfer.files;
    let fileList: Array<DroppedFile> = [];
    if (files.length > 0) {
      for (const file of files) {
        let ext = file.name.split(".")[file.name.split(".").length - 1];
        fileList.push({
          isValid: this.appDragAndDropFile.toString().includes(ext),
          file: file
        });
      }
      this.onDroppedFileListChanged.emit(fileList);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/drag-and-drop-file/drag-and-drop-file.directive.ts